import { useCallback, useEffect, useState } from 'react';
import { WPSearchResultItem } from '../../typings';
import { JobRow } from '../JobRow/JobRow';
import * as styles from './SimilarOpportunities.module.scss';
import { searchPosts } from '../../services/common.service';
import Pagination from '../Pagination/Pagination';

interface SimilarOpportunitiesProps {
  keyword?: string;
  professionalCommunity?: string[];
  contractType?: string[];
  experienceLevel?: string[];
  jobsIdList?: string[];
}

interface Window {
  cg_jobs_es_var?: { pathName ?: string};
  cg_jobs_country_codes?: string;
  cg_jobs_country_code?: string;
}
const countryCodeinSettings = (window as Window).cg_jobs_country_code;
const cCode = countryCodeinSettings ? countryCodeinSettings : (window as Window).cg_jobs_es_var?.pathName;
const { __ } = window.wp.i18n;

export const SimilarOpportunities: React.FC<SimilarOpportunitiesProps> = (props) => {
  const [jobList, setJobList] = useState<WPSearchResultItem[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const perPage = 6;

  useEffect(() => {     
    fetchListings(); 
  }, [currentPage])
  
  const fetchListings = async () => {  

    const currentFilters = {
      professional_communities: props.professionalCommunity,
      contract_type: props.contractType,
      experience_level: props.experienceLevel
    }

    searchPosts({ size: perPage, page: currentPage, country_code: cCode, filters: currentFilters })
    .then(data => {
      if (data.count < 6) {
        return searchPosts({ 
          size: perPage, 
          page: currentPage, 
          country_code: cCode, 
          filters: { professional_communities: props.professionalCommunity } 
        });
      }
      return data;
    })
    .then(data => {
      if (data.count < 6) {
        return searchPosts({ size: perPage, country_code: cCode });
      }
      return data;
    })
    .then(data => {
      const newJobs = props.jobsIdList ? data.data.filter(job => props.jobsIdList && !props.jobsIdList.includes(job.id)) : data.data;
      // Update the job list with only the new jobs
     
      setJobList(newJobs);
      setTotalPages(Math.ceil(data.count / perPage));
    })
    .catch(error => {
      console.error('Error fetching listings:', error);
    });
    
  };

  const handleSimilarPageChange = useCallback((page: number) => {   
    setCurrentPage(page);   
    setTimeout(() => {
      const element = document.querySelector('#similar-jobs');
      if (element) {
        const offsetTop = element.getBoundingClientRect().top + window.scrollY; // Calculate the offset
        window.scrollTo(0, offsetTop);        
      }                                   
    }, 0);
  }, []);
      
  return (   
    <>
      <div className={styles["similar-heading"]} id="similar-jobs">
      { __( 'Explore similar opportunities', 'cg-jobs' ) }
      </div> 
      <ul className={styles['similar-job-list']}> 
        {jobList.map((job:WPSearchResultItem) => <JobRow key={job.id} id={job.id} refId={job.ref ?? ""} source={job.source} title={job.title} location={job.location} sbu={job.sbu} contract_type={job.contract_type} department={job.department} experience_level={job.experience_level} professional_communities={job.professional_communities}/>)}     
      </ul> 
      <div className={styles['pagination-similar']}>
        {totalPages > 1 && <Pagination totalPages={totalPages} currentPage={currentPage} onPageChange={handleSimilarPageChange} />}              
      </div>
  </>
  )
}